import { createAction, props } from '@ngrx/store';
import { LeaseDTO, CreateLeaseRequest, UpdateLeaseRequest } from '../../model/lease.model';

export const loadLeases = createAction('[Lease] Load Leases');

export const loadLeasesSuccess = createAction('[Lease] Load Leases Success', props<{ leases: LeaseDTO[] }>());

export const loadLeasesFailure = createAction('[Lease] Load Leases Failure', props<{ error: any }>());

export const createLease = createAction('[Lease] Create Lease', props<{ request: CreateLeaseRequest }>());

export const createLeaseSuccess = createAction('[Lease] Create Lease Success', props<{ lease: LeaseDTO }>());

export const createLeaseFailure = createAction('[Lease] Create Lease Failure', props<{ error: any }>());

export const updateLease = createAction('[Lease] Update Lease', props<{ id: number; request: UpdateLeaseRequest }>());

export const updateLeaseSuccess = createAction('[Lease] Update Lease Success', props<{ lease: LeaseDTO }>());

export const updateLeaseFailure = createAction('[Lease] Update Lease Failure', props<{ error: any }>());

export const uploadLeaseFile = createAction('[Lease File] Upload Lease File', props<{ id: number; file: File }>());

export const uploadLeaseFileSuccess = createAction('[Lease File] Upload Lease File Success', props<{ id: number }>());

export const uploadLeaseFileFailure = createAction('[Lease File] Upload Lease File Failure', props<{ error: any }>());

export const updateLeaseFile = createAction('[Lease File] Update Lease File', props<{ id: number; file: File }>());

export const updateLeaseFileSuccess = createAction('[Lease File] Update Lease File Success', props<{ id: number }>());

export const updateLeaseFileFailure = createAction('[Lease File] Update Lease File Failure', props<{ error: any }>());

export const viewLeaseFile = createAction('[Lease File] View Lease File', props<{ fileId: number }>());

export const viewLeaseFileSuccess = createAction('[Lease File] View Lease File Success', props<{ fileId: number; blob: Blob }>());

export const viewLeaseFileFailure = createAction('[Lease File] View Lease File Failure', props<{ error: any }>());

export const downloadLeaseFile = createAction('[Lease File] Download Lease File', props<{ fileId: number }>());

export const downloadLeaseFileSuccess = createAction('[Lease File] Download Lease File Success', props<{ fileId: number; blob: Blob }>());

export const downloadLeaseFileFailure = createAction('[Lease File] Download Lease File Failure', props<{ error: any }>());

export const uploadLeaseFiles = createAction('[Lease File] Upload Lease Files', props<{ id: number; files: File[] }>());

export const uploadLeaseFilesSuccess = createAction('[Lease File] Upload Lease Files Success', props<{ id: number }>());

export const uploadLeaseFilesFailure = createAction('[Lease File] Upload Lease Files Failure', props<{ error: any }>());

export const deleteLeaseFile = createAction('[Lease File] Delete Lease File', props<{ fileId: number }>());

export const deleteLeaseFileSuccess = createAction('[Lease File] Delete Lease File Success', props<{ fileId: number }>());

export const deleteLeaseFileFailure = createAction('[Lease File] Delete Lease File Failure', props<{ error: any }>());
